export const navItems = [
  { label: '首頁', path: '/' },
  { label: '品牌介紹', path: '/about' },
  { label: '合作通路', path: '/stores' },
  { label: '常見問題', path: '/faq' },
  { label: '閱讀推薦', path: '/blog' },
];

export const siteInfo = {
  brandName: '沐燁文化 Moya',
  brandNameShort: '沐燁文化',
  englishName: 'MOYA',
  parentBrand: '崧博出版',
  siteUrl: 'https://moya.sonbook.net/',
  parentUrl: 'https://sonbook.net/',
  catalogUrl: 'https://catalog.sonbook.net/',
  brandRelationText: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。',
  publishingDirectionText: 'AIGC 彩色書籍與史密森學會科普內容',
  siteDescription:
    '沐燁文化以 AIGC 彩色書籍與史密森學會相關科普內容為主要出版方向，透過圖像與文字呈現自然、科學及知識主題。',
  aigcNote: '部分出版內容運用生成式人工智慧輔助圖像或內容呈現，實際製作與使用方式以個別書籍正式資料為準。',
  smithsonianNote: '史密森學會相關內容之來源、授權及出版資訊，以個別書籍正式資料為準。',
  scienceContentNote: '網站所呈現內容為出版與一般科普閱讀資訊，不能取代正式研究、專業教育、醫療診斷或其他專業意見。',
  individualWorksNote: '個別作品內容與作者觀點，不代表沐燁文化或崧博出版的官方立場。',
  catalogDisclaimer: '完整書名、作者、ISBN、內容來源、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。',
  imageDisclaimer: '書籍中的圖像與視覺內容以知識呈現與閱讀輔助為目的，實際科學、歷史及物種資訊以個別出版資料及可靠專業來源為準。',
};

export const brandValues = [
  {
    id: 'brand-identity',
    title: '委託崧博出版經銷',
    description: '沐燁文化 Moya 委託崧博出版經銷，官方網站由崧博出版製作。擁有獨立品牌識別，品牌經銷與合作方案詳情請直接聯繫洽詢。',
    icon: 'ri-building-line',
  },
  {
    id: 'catalog',
    title: '書籍資料庫查詢',
    description: '正式出版書籍的書名、作者、ISBN、出版日期及完整書目資訊，可前往崧博出版書籍資料庫查詢。',
    icon: 'ri-database-2-line',
  },
  {
    id: 'channels',
    title: '品牌書目通路',
    description: '讀者可透過博客來品牌書目與崧博出版官方網站，搜尋沐燁文化 Moya 正式出版書籍。',
    icon: 'ri-store-line',
  },
  {
    id: 'contact',
    title: '品牌經銷合作',
    description: '如有書籍、購書、版權、媒體或品牌經銷合作相關問題，請直接聯繫洽詢。',
    icon: 'ri-mail-line',
  },
];

export const publishingDirections = [
  { name: '品牌介紹', icon: 'ri-building-line' },
  { name: '正式出版書籍', icon: 'ri-book-3-line' },
  { name: '合作通路', icon: 'ri-store-line' },
  { name: '書籍資料庫', icon: 'ri-database-2-line' },
  { name: '品牌經銷合作', icon: 'ri-service-line' },
];

export const faqItems = [
  {
    q: '沐燁文化 Moya 是什麼？',
    a: '沐燁文化 Moya 以 AIGC 彩色書籍與史密森學會相關科普內容為主要出版方向，透過圖像與文字呈現自然、科學及知識主題。本品牌委託崧博出版經銷，官方網站由崧博出版製作。本網站提供品牌介紹、正式出版書籍及崧博出版書籍資料庫查詢入口。',
  },
  {
    q: '沐燁文化 Moya 和崧博出版是什麼關係？',
    a: '沐燁文化 Moya 委託崧博出版經銷，官方網站由崧博出版製作。沐燁文化擁有獨立品牌識別與市場定位，品牌經銷與合作方案詳情請直接聯繫洽詢。',
  },
  {
    q: '沐燁文化 Moya 主要出版什麼內容？',
    a: '沐燁文化 Moya 主要出版方向為 AIGC 彩色書籍與史密森學會科普內容。AIGC 是部分出版內容的圖像或呈現方式，不代表沐燁文化提供 AI 生圖、AI 寫作或出版代工服務。史密森學會相關內容之來源、授權及出版資訊，以個別書籍正式資料為準。',
  },
  {
    q: '沐燁文化 Moya 的書在哪裡可以購買？',
    a: '讀者可透過博客來品牌書目與崧博出版官方網站（sonbook.net）搜尋沐燁文化 Moya 正式出版書籍。不同平台上架狀態可能有所不同，請以各平台頁面為準。',
  },
  {
    q: '如何查詢完整的書籍書目資訊？',
    a: '正式出版書籍的 ISBN、出版日期及完整書目資訊，請前往崧博書籍資料庫查詢。完整書名、作者、ISBN、內容來源、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。',
  },
  {
    q: '什麼是 AIGC 彩色書籍？',
    a: 'AIGC 彩色書籍是指部分出版內容運用生成式人工智慧輔助圖像或內容呈現，透過彩色圖像與知識內容的結合，提供更具視覺性與閱讀性的出版作品。沐燁文化不提供對外 AI 生圖、AI 寫作、系統導入或出版代工服務。',
  },
  {
    q: '如何聯繫沐燁文化 Moya？',
    a: '如有書籍、購書、版權、媒體或品牌經銷合作相關問題，請透過崧博出版官方網站（sonbook.net）聯繫。品牌經銷與合作方案詳情請直接聯繫洽詢。',
  },
];

export const brandStory = {
  title: '關於沐燁文化',
  subtitle: '沐燁文化 Moya 委託崧博出版經銷，官方網站由崧博出版製作。',
  content: [
    '沐燁文化 Moya 以 AIGC 彩色書籍與史密森學會相關科普內容為主要出版方向，透過圖像與文字呈現自然、科學及知識主題。本品牌委託崧博出版經銷，官方網站由崧博出版製作。',
    '正式出版書籍的書名、作者、ISBN、出版日期及完整書目資訊，可前往崧博出版書籍資料庫查詢。',
    '品牌經銷與合作方案詳情請直接聯繫洽詢。',
  ],
};

export const channels = [
  {
    id: 'books-com-tw',
    name: '博客來',
    title: '博客來品牌書目',
    description: '前往博客來沐燁文化 Moya 品牌專區，瀏覽正式出版書籍目錄與上架資訊。',
    url: 'https://www.books.com.tw/web/sys_puballb/books/?pubid=sungpo7',
    icon: 'ri-shopping-bag-line',
  },
  {
    id: 'eslite',
    name: '誠品',
    title: '誠品線上',
    description: '於誠品線上搜尋沐燁文化 Moya 正式出版書籍，查詢門市庫存與線上購買資訊。',
    url: 'https://www.eslite.com/search?keyword=沐燁文化',
    icon: 'ri-book-3-line',
  },
  {
    id: 'kingstone',
    name: '金石堂',
    title: '金石堂網路書店',
    description: '前往金石堂沐燁文化出版專區，瀏覽書籍目錄、查詢門市庫存與線上訂購。',
    url: 'https://www.kingstone.com.tw/bookpublish/publist/62459/',
    icon: 'ri-book-3-line',
  },
  {
    id: 'sanmin',
    name: '三民',
    title: '三民網路書店',
    description: '於三民網路書店搜尋沐燁文化出版品，查詢書籍資訊與購買選項。',
    url: 'https://www.sanmin.com.tw/search?pu=沐燁文化',
    icon: 'ri-book-3-line',
  },
  {
    id: 'momo',
    name: 'momo',
    title: 'momo 購物網',
    description: '於 momo 購物網搜尋沐燁文化品牌書籍，查詢線上購買與配送資訊。',
    url: 'https://www.momoshop.com.tw/search/%E6%B2%90%E7%87%81%E6%96%87%E5%8C%96?brand=沐燁文化',
    icon: 'ri-shopping-cart-line',
  },
  {
    id: 'shopee',
    name: '蝦皮',
    title: '蝦皮購物',
    description: '前往蝦皮崧博出版賣場，瀏覽沐燁文化 Moya 及其他品牌出版書籍。',
    url: 'https://shopee.tw/sonbook',
    icon: 'ri-shopping-cart-line',
  },
  {
    id: 'amazon-kindle',
    name: 'Amazon Kindle',
    title: 'Amazon Kindle 電子書',
    description: '於 Amazon Kindle 搜尋沐燁文化出版品，查詢電子書版本與國際購買資訊。',
    url: 'https://www.amazon.com/s?k=沐燁文化',
    icon: 'ri-global-line',
  },
  {
    id: 'taaze',
    name: 'TAAZE 讀冊',
    title: 'TAAZE 讀冊生活',
    description: '於 TAAZE 讀冊搜尋沐燁文化書籍，查詢新書與二手書購買選項。',
    url: 'https://www.taaze.tw/rwd_searchResult.html?keyType%5B%5D=3&keyword%5B%5D=沐燁文化',
    icon: 'ri-book-open-line',
  },
  {
    id: 'kobo',
    name: '樂天 Kobo',
    title: '樂天 Kobo 電子書',
    description: '前往樂天 Kobo 台灣，搜尋沐燁文化出版品的電子書版本。',
    url: 'https://www.kobo.com/tw/zh',
    icon: 'ri-tablet-line',
  },
  {
    id: 'pubu',
    name: 'Pubu',
    title: 'Pubu 電子書城',
    description: '前往 Pubu 沐燁文化品牌專區，瀏覽電子書與 PDF 出版品。',
    url: 'https://www.pubu.com.tw/store/4193937',
    icon: 'ri-tablet-line',
  },
  {
    id: 'overdrive',
    name: 'OverDrive',
    title: 'OverDrive 電子書',
    description: '於 OverDrive 搜尋沐燁文化出版品，提供圖書館與機構電子書借閱。',
    url: 'https://www.overdrive.com/publishers/沐燁文化',
    icon: 'ri-building-line',
  },
  {
    id: 'mybook',
    name: 'MyBook',
    title: 'MyBook 電子書',
    description: '前往台灣大哥大 MyBook 電子書平台，搜尋沐燁文化出版品。',
    url: 'https://mybook.mobi/mybook/zh-TW/#',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'hami-book',
    name: 'Hami Book',
    title: 'Hami Book 電子書',
    description: '前往中華電信 Hami Book 搜尋沐燁文化出版品，查詢電子書版本。',
    url: 'https://www.hamibook.com.tw/Search/finish?keyword=沐燁文化',
    icon: 'ri-smartphone-line',
  },
  {
    id: 'sungpo',
    name: '崧博出版',
    title: '崧博出版主站',
    description: '前往崧博出版官網，了解出版服務、合作通路與其他經銷品牌資訊。',
    url: 'https://sonbook.net/',
    icon: 'ri-store-line',
  },
];
